module.exports = __webpack_public_path__ + "img/kaisan.a48a5d36.webp";